export default __webpack_public_path__ + "static/media/spooky_hill_xl1.a07826c9.png";